import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { getSelectOptions } from '@panneau/core/utils';

var propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes$1.selectOptions,
  withBackground: PropTypes.bool,
  disabled: PropTypes.bool,
  uncheckable: PropTypes.bool,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps = {
  name: null,
  value: null,
  options: [],
  withBackground: false,
  disabled: false,
  uncheckable: false,
  className: null,
  buttonClassName: null,
  onChange: null
};
var Radios = function Radios(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    withBackground = _ref.withBackground,
    disabled = _ref.disabled,
    uncheckable = _ref.uncheckable,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    onChange = _ref.onChange;
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-block', 'btn-group', 'btn-group-toggle', _defineProperty({}, className, className !== null)]),
    "data-toggle": "buttons",
    style: {
      zIndex: 0
    }
  }, finalOptions.map(function (_ref3, index) {
    var _ref3$value = _ref3.value,
      optionValue = _ref3$value === void 0 ? null : _ref3$value,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? null : _ref3$label;
    // eslint-disable-next-line eqeqeq
    var isCurrent = optionValue == value; // Loose to handle numeric values from parseQuery
    return /*#__PURE__*/React.createElement("label", {
      key: "radio-".concat(optionValue, "-").concat(index + 1),
      className: classNames(['btn', withBackground ? 'btn-secondary' : 'btn-outline-secondary', _defineProperty({
        active: isCurrent,
        disabled: disabled
      }, buttonClassName, buttonClassName !== null)])
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: name,
      className: "btn-check",
      autoComplete: "off",
      disabled: disabled,
      value: optionValue || '',
      onClick: function onClick(e) {
        if (onChange !== null) {
          if (uncheckable && isCurrent) {
            onChange(null);
          } else {
            onChange(e.currentTarget.checked ? optionValue : null);
          }
        }
      },
      onChange: function onChange() {},
      checked: isCurrent
    }), label);
  }));
};
Radios.propTypes = propTypes;
Radios.defaultProps = defaultProps;

export { Radios as default };
